import styled from 'styled-components'

export const CartComponent = styled.div`
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.grey0};
  position: fixed;
  box-shadow: 4px 0px 8px rgba(0, 0, 0, 1);
  height: 100%;
  min-height: fill-available;
  right: 0px;
  top: 0;
  bottom: 0px;
  width: 100%;
  transform: ${({ isOpened }) => (isOpened ? ' translateX(0)' : ' translateX(100%)')};
  max-width: 434px;
  display: flex;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    padding: 24px;
  }

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    max-width: 447px;
  }
`
export const CartBody = styled.ul`
  overflow-y: scroll;
  margin: 24px 0;
  padding: 0;
  ::-webkit-scrollbar {
    width: 4px;
  }
  > * {
    &:last-child {
      margin-bottom: 0;
    }
  }
`

export const CartItems = styled.div`
  height: 100px;
  background-color: crimson;
  margin: 0 0 16px 0;
`
export const CartFooter = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: auto;
`
export const CartButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
`
export const ContentLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  margin-bottom: 20px;
`

export const LegalAvisoRedirect = styled.h6`
  padding-top: 8px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
`
